// Import all bank logos
import chaseLogo from '../assets/bank-logos/chase-logo.png';
import wellsFargoLogo from '../assets/bank-logos/wells-fargo-logo.png';
import bankOfAmericaLogo from '../assets/bank-logos/bank-of-america-logo.svg';
import tdBankLogo from '../assets/bank-logos/td-bank-logo.svg';
import capitalOneLogo from '../assets/bank-logos/capital-one-logo.svg';
import pncLogo from '../assets/bank-logos/pnc-logo.svg';
import usBankLogo from '../assets/bank-logos/us-bank-logo.svg';
import navyFederalLogo from '../assets/bank-logos/navy-federal-logo.svg';
import citibankLogo from '../assets/bank-logos/citibank-logo.svg';
import huntingtonLogo from '../assets/bank-logos/huntington-logo.svg';
import amexLogo from '../assets/bank-logos/amex-logo.svg';
import discoverLogo from '../assets/bank-logos/discover-logo.svg';
import defaultBankLogo from '../assets/bank-logos/default-bank.svg';

// Default placeholder for missing logos
const defaultLogo = defaultBankLogo;

// Bank logo mapping
export const bankLogos: Record<string, string> = {
  'chase-logo.png': chaseLogo,
  'wells-fargo-logo.png': wellsFargoLogo,
  'bank-of-america-logo.svg': bankOfAmericaLogo,
  'td-bank-logo.svg': tdBankLogo,
  'capital-one-logo.svg': capitalOneLogo,
  'pnc-logo.svg': pncLogo,
  'us-bank-logo.svg': usBankLogo,
  'navy-federal-logo.svg': navyFederalLogo,
  'citibank-logo.svg': citibankLogo,
  'huntington-logo.svg': huntingtonLogo,
  'amex-logo.svg': amexLogo,
  'discover-logo.svg': discoverLogo,
};

/**
 * Get the actual logo URL from the logo filename
 */
export const getBankLogo = (logoFilename: string): string => {
  return bankLogos[logoFilename] || defaultLogo;
}; 